module.exports = __webpack_public_path__ + "img/schema_minerve.883a6d5b.svg";